import styled from "styled-components";
import InputBoxDisableTrans from "../Components/InputBoxDisableTrans";
import { ReactComponent as IconSetPW } from "../Images/icon_setPW.svg";
import "../Styles/component.css";
import "../Styles/fonts.css";
import "../Styles/global.css";
import { useGoToAddr } from "../Utils/navigationUtils";

const ExpiredUpdatePW = () => {
  const goToAddr = useGoToAddr();
  return (
    <div className="page-wrapper center" style={{ height: "1080px" }}>
      <PWBox>
        <div className="hrz-wrapper center" style={{ marginTop: "70px" }}>
          <IconSetPW />
        </div>
        <div className="hrz-wrapper center" style={{ marginTop: "14px" }}>
          <p className="infoTitle">비밀번호를 변경해주세요!</p>
        </div>

        <div className="hrz-wrapper center" style={{ marginTop: "14px" }}>
          <p style={{ color: "#222222" }}>
            회원님께서는 오랜 기간 비밀번호를 변경하지 않으셨습니다.
          </p>
        </div>
        <div className="hrz-wrapper center">
          <p style={{ color: "#222222" }}>
            개인정보를 보호하고 개인정보도용의 피해를 예방하기 위해
          </p>
          <p style={{ color: "#1167ed", fontFamily: "notoSans-medium" }}>
            &nbsp;6개월마다
          </p>
        </div>
        <div className="hrz-wrapper center">
          <p style={{ color: "#222222" }}>
            주기적으로 비밀번호 변경을 권장하고 있습니다.
          </p>
        </div>

        <div className="hrz-wrapper center" style={{ marginTop: "10px" }}>
          <p style={{ color: "#222222" }}>
            비밀번호 변경 후 기존 계정은 로그아웃됩니다.
          </p>
        </div>

        <div className="center">
          <div style={{ marginTop: "30px" }}>
            <InputBoxDisableTrans message="현재 비밀번호" type="password" />
            <div style={{ height: "10px" }} />
            <InputBoxDisableTrans
              message="신규 비밀번호(영문/숫자/특수문자 8~16자리)"
              type="password"
            />
            <div style={{ height: "10px" }} />
            <InputBoxDisableTrans
              message="신규 비밀번호 재입력"
              type="password"
            />
          </div>
        </div>

        <div className="hrz-wrapper center" style={{ marginTop: "40px" }}>
          <div
            className="blueBtn-base center"
            style={{
              width: "193px",
              height: "56px",
              borderRadius: "10px",
              fontFamily: "notoSans-medium",
            }}
          >
            변경하기
          </div>

          <div style={{ width: "14px" }} />

          <div
            className="blueBorderBtn-base center"
            style={{
              width: "193px",
              height: "56px",
              borderRadius: "10px",
              fontFamily: "notoSans-medium",
            }}
            onClick={() => goToAddr("login")}
          >
            다음에 변경하기
          </div>
        </div>
      </PWBox>
    </div>
  );
};

const PWBox = styled.div`
  width: 860px;
  height: 725px;
  border-radius: 20px;
  background-color: #ffffff;
  .infoTitle {
    font-family: "notoSans-bold";
    font-size: 24px;
    color: #222222;
  }
`;
export default ExpiredUpdatePW;
